import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const ReCaptcha = ({ getCaptcha, sitekey }) => {
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
    getCaptcha(value);
  };
  return <ReCAPTCHA sitekey={sitekey} onChange={handleRecaptchaChange} />;
};
export default ReCaptcha;
